module.exports = __webpack_public_path__ + "img/auth.4d55fd58.png";